import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import ResetPasswordScreen from '../screens/ResetPasswordScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('reset-password')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ResetPasswordScreen />
    </StrictMode>,
  )
}

bootstrap()
